import { FieldKey, t } from '../i18n';

const validateLength = (value: string, maxLength: number, field: FieldKey): string => {
    if (value.length <= maxLength) {
        return '';
    }
    const endsWithOne = String(maxLength).endsWith('1') && !String(maxLength).endsWith('11');
    return t(endsWithOne ? 'length-one' : 'length', { field: t(field), max: maxLength });
};

export default validateLength;
